export const environment = {
  production: true,
  apiUrl: 'https://buddy.oasis.co.kr:7888',
};
